import { useState } from "react";

import api from "api/api";
import { IDirectUpload } from "config";
import { useAppDispatch } from "store";
import { createDirectUpload } from "store/actions";

export function useDirectUpload() {
  const dispatch = useAppDispatch();
  const [uploadState, setUploadState] = useState<"idle" | "uploading" | "done" | "error">("idle");

  return {
    uploadState,
    uploadFile: async (
      file: File,
      onSuccess?: (signedBlobId: IDirectUpload["signedBlobId"]) => Promise<void>
    ) => {
      setUploadState("uploading");

      // Grab a pre-signed URL from our backend API:
      const directUpload = await dispatch(createDirectUpload(file)).unwrap();

      // Upload the file to the pre-signed URL:
      await api.directUpload.uploadFile(file, directUpload);

      setUploadState("done");

      // Call the onSuccess callback with the signedBlobId
      if (onSuccess) {
        await onSuccess(directUpload.signedBlobId);
      }

      return directUpload.signedBlobId;
    },
  };
}
